import { isMobilePurpleUseragent, makeElement } from "../../../common/Utils";
import { AbsSocial } from "./AbsSocial";
import { ga360 } from '../socials/GA360';

export class Facebook extends AbsSocial {
    name: SocialName = 'facebook';
    dataContents = ga360.dataContents.faceboodk;
    dataArea = ga360.dataArea.common;

    constructor(protected ElShareItemWrap: HTMLElement, protected option: ShareOption){
        super(ElShareItemWrap, option);

        this.init();
    }

    async callShare(){
      const targetUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + this.option.shareUrl;

      if(isMobilePurpleUseragent()){
          location.href = `ncmtalk://external?url=${targetUrl}`;
      }else{
          window.open(targetUrl, '_blank');
      }
    }
    

}
